export const requestApp = (type: string, data?: any) => {
    if (!window.ReactNativeWebView) return; // 웹뷰가 아닐 경우에는 return
    window.ReactNativeWebView?.postMessage(JSON.stringify({ type, data: data || {} }))
}

export const APP_TO_WEB = {
    INSET_INFO: "INSET_INFO",
    DEVICE_INFO: "DEVICE_INFO"
}

export const WEB_TO_APP = {
    LOGS: "LOGS",
    MSG_READY : "MSG_READY",
    SEND_TOKEN: "SEND_TOKEN",
    SAVE_USER_INFO: "SAVE_USER_INFO",
    CLEAR_USER_INFO: "CLEAR_USER_INFO",
    OPEN_POPUP: "OPEN_POPUP",
    CLOSE_POPUP: "CLOSE_POPUP",
}

// 팝업 열기 함수들
export const openNoticePopup = () => {
    requestApp(WEB_TO_APP.OPEN_POPUP, { url: '/wiz-common/notice', title: '공지사항' });
}

export const openFaqPopup = () => {
    requestApp(WEB_TO_APP.OPEN_POPUP, { url: '/wiz-common/faq', title: 'FAQ' });
}

export const openQnaPopup = () => {
    requestApp(WEB_TO_APP.OPEN_POPUP, { url: '/wiz-common/qna', title: '의견보내기' });
}

export const openTermsPopup = (termsType?: string) => {
    requestApp(WEB_TO_APP.OPEN_POPUP, { url: `/wiz-common/terms${termsType ? `?type=${termsType}` : ''}`, title: '약관' });
}

export const closePopup = () => {
    requestApp(WEB_TO_APP.CLOSE_POPUP, {});
}

// 네이티브에서 받은 이벤트 가공
export const msgData = (event: MessageEvent) => {
    const originData = event?.data;
    if (!originData) return { type: undefined, data: undefined };

    let response;
    try {
        response = JSON.parse(originData || '{}');
    } catch (error) {
        return { type: undefined, data: undefined };
    }

    const type = (response?.type as string)?.toUpperCase();
    let data = response.data;
    try {
        data = JSON.parse(response.data);
    } catch (error) {
        data = response.data;
    }

    return { type, data };
}
